import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, Table, Tag, Form } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import Modal from '@mui/material/Modal';
import { DatePicker, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { DataGrid, GridCellParams, GridSortDirection, GridToolbar } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { UIStore } from "../store/store";
import Equipment from './Equipment';
import { keyframes } from 'styled-components';
import { Theme, createStyles, makeStyles } from '@mui/material/styles';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import StarBorderIcon from '@material-ui/icons/StarBorder';


const ListingsDetails: React.FC = (props: any) => {

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
      },
      imageList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
      },
      title: {
        color: theme.palette.primary.light,
      },
      titleBar: {
        background:
          'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
      },
      paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
      },
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },

    }),
  );

  const classes = useStyles();

  const currentListing = UIStore.useState(s => s.SelectedListings);

  const amenitiesColumns = [

    { field: 'id', headerName: 'ID', width: 200 },
    { field: 'Name', headerName: 'Name', width: 200 },
    { field: 'Room', headerName: 'Room', width: 200 },
    { field: 'Property', headerName: 'Property', width: 200 },
    { field: 'Status', headerName: 'Status', width: 200 },
  ];

  const equipmentColumns = [

    { field: 'id', headerName: 'ID', width: 200 },
    { field: 'Name', headerName: 'Name', width: 200 },
    { field: 'Status', headerName: 'Status', width: 200 },
  ];


  useEffect(() => {
    (async () => {
      setState(currentListing);
      // console.log(currentListing);  
    })()
  }, [])

  const [open, setOpen] = React.useState(false);
  const [img, setImg] = React.useState({});

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handlePicClick = (e: any) => {
    //console.log(e.target.src)
    setImg(e.target.src)
    handleOpen();
  };



  const user = JSON.parse(localStorage.getItem("userobject") || '{}');

  const [ListingObject, setState] = useState({});



  return (

    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              title="Listings Details"
            />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen >
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{ }</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "40px" }}>
                <IonCard>
                  <IonCardHeader>
                    <IonCol>
                      <Link to={{ pathname: "/Listings" }}  >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          style={{ marginLeft: 25 }} > Back</Button>
                      </Link>
                    </IonCol>
                    <br></br>
                    <Modal
                      className={classes.modal}
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="simple-modal-title"
                      aria-describedby="simple-modal-description"
                    >
                      <div className={classes.paper}>
                        {/* @ts-ignore */}
                        <img className={classes.img} src={img} alt="Property" />
                      </div>
                    </Modal>


                  </IonCardHeader>

                  <IonCardContent>
                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Name" variant="outlined" value={currentListing.PropertyID.Name} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Address" variant="outlined" value={currentListing.PropertyID.Address} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Country" variant="outlined" value={currentListing.PropertyID.Country} />
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Property Suburb" variant="outlined" value={currentListing.PropertyID.Suburb} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Property City" variant="outlined" value={currentListing.PropertyID.City} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Property Province" variant="outlined" value={currentListing.PropertyID.Province} />
                      </IonCol>


                    </IonRow>
                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Description" variant="outlined" value={currentListing.PropertyID.Description} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Furnished Type" variant="outlined" value={currentListing.PropertyID.FurnishedType} />
                      </IonCol>

                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Monthly Rent" variant="outlined" value={currentListing.PropertyID.MonthlyRent} />
                      </IonCol>
                    </IonRow>

                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Number of Rooms" variant="outlined" value={currentListing.PropertyID.numberofrooms} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Payment Status" variant="outlined" value={currentListing.PaymentStatus} />
                      </IonCol>

                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Property Type" variant="outlined" value={currentListing.PropertyID.PropertyType} />
                      </IonCol>
                    </IonRow>

                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Status" variant="outlined" value={currentListing.Status} />
                      </IonCol>

                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="created" variant="outlined" value={currentListing.PropertyID.created} />
                      </IonCol>

                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Listing Type" variant="outlined" value={currentListing.ListingType} />
                      </IonCol>

                    </IonRow>

                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Listing Fees" variant="outlined" value={currentListing.ListingFees} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Property Uses" variant="outlined" value={currentListing.PropertyID.PropertyUses} />
                      </IonCol>
                      <IonCol></IonCol>

                    </IonRow>



                    <IonRow>
                      <IonRow>
                        <IonCol>
                          <h2><strong>List of Property Amenities</strong></h2>
                          <div style={{ height: 400, width: '80vw', paddingRight: "2vw" }}>

                            <DataGrid
                              /* @ts-ignore */
                              rows={currentListing.PropertyID.ammenities}
                              columns={amenitiesColumns}
                              components={{
                                Toolbar: GridToolbar,
                              }}
                              sortModel={[
                                {
                                  field: 'Name',
                                  sort: 'asc' as GridSortDirection,
                                },
                              ]}
                            />
                          </div>
                        </IonCol>
                      </IonRow>

                      <IonRow>
                        <IonCol>

                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol>
                          <h2><strong>List of Property Equipment</strong></h2>
                          <div style={{ height: 400, width: '80vw', paddingRight: "2vw" }}>
                            <DataGrid
                              /* @ts-ignore */
                              rows={currentListing.PropertyID.equipment}
                              columns={equipmentColumns}
                              components={{
                                Toolbar: GridToolbar,
                              }}
                              sortModel={[
                                {
                                  field: 'Name',
                                  sort: 'asc' as GridSortDirection,
                                },
                              ]}
                            />
                          </div>
                        </IonCol>
                      </IonRow>

                      <IonRow>
                        <IonCol>
                          <h2><strong>Property Images</strong></h2>

                          <ImageList className={classes.imageList} cols={2.5}>
                            {/* @ts-ignore */}
                            {currentListing.PropertyID.photos.map((item) => (
                              <ImageListItem key={item.img}>
                                <img src={item.FilePath} alt={"Property"} onClick={(e) => handlePicClick(e)} />

                              </ImageListItem>
                            ))}
                          </ImageList>

                        </IonCol>
                      </IonRow>
                    </IonRow>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>
  );
}

export default ListingsDetails;